import React from 'react';

import Table from '../../../../../Table';
import Search from './Search';

import useUserRole from '../../../../../../hooks/useUserRole';
import { useUiContext } from '../../../../../../context/UiContext';
import formatBorrowerName from '../../../../../../helpers/formatBorrowerName';
import getLoanNumber from '../../../../../../helpers/getLoanNumber';
import createLoanStatusBadgeColor from '../../../../../../helpers/tables/createLoanStatusBadgeColor';

export default function Loans({ updateLoanGroup, loanGroup }) {
  const { showDialogModal } = useUiContext();

  const { isLender } = useUserRole();

  const cols = [
    {
      title: 'Loan number',
      keys: ['pixel_loan_number'],
      format: (value, row) => {
        if (isLender) {
          return getLoanNumber(row);
        }
        return value;
      },
      link: (row) => `/loans/${row.id}?tab=Loan`,
    },
    {
      title: 'Borrower',
      keys: ['_borrower_primary'],
      format: formatBorrowerName,
    },
    {
      title: 'Property',
      keys: ['_property.address_line_1'],
    },
    {
      title: 'Close date',
      keys: ['close_date'],
      type: 'date',
    },
    {
      title: 'Remaining principal',
      keys: ['doesntmatter'],
      format: (_, row) => {
        if (!row?._principal_paid) {
          return row?.original_principal || 0;
        }

        return (
          (row?.original_principal ?? 0) - (row?._principal_paid?.total ?? 0)
        );
      },
      type: 'currency',
    },
    {
      title: 'Rate',
      keys: ['rate'],
      type: 'percentage',
    },
    {
      title: 'Participation rate',
      keys: ['_participations'],
      type: 'percentage',
      format: (value) => {
        const sumInt = value
          .map((v) => Math.round(v.rate * 10000))
          .reduce((a, b) => a + b, 0);

        return sumInt / 10000;
      },
    },
    {
      title: 'Status',
      keys: ['status'],
      type: 'badge',
      badgeColor: createLoanStatusBadgeColor,
      link: (row) => `/loans/${row.id}?tab=Loan`,
    },
    {
      title: '',
      type: 'delete',
      onClick: (row) => {
        showDialogModal({
          title: 'Remove Loan from Group',
          message: `Are you sure you want to remove this loan from this loan group?`,
          onConfirm: () => {
            const prevIds = loanGroup?.loan_id
              ?.filter(Boolean)
              ?.map((loan) => loan._loan.id);

            const newLoanIds = prevIds.filter((loanId) => loanId !== row.id);

            updateLoanGroup({
              ...loanGroup,
              loan_id: newLoanIds,
            });
          },
          type: 'danger',
          confirmButtonLabel: 'Yes, remove it',
          cancelButtonLabel: 'No, cancel',
        });
      },
    },
  ];

  return (
    <div>
      <h3 className="text-xl text-slate-800 dark:text-slate-100 font-bold flex justify-between w-full mb-6">
        Add Loan
      </h3>
      <Search loanGroup={loanGroup} updateLoanGroup={updateLoanGroup} />
      <Table
        rows={loanGroup?.loan_id?.filter(Boolean)?.map((loan) => loan?._loan)}
        cols={cols}
        title="Loans"
      />
    </div>
  );
}
